import { AppState } from "../types";

export const adminSelectors = {
  googleCalendars(state: AppState) {
    return state.admin.googleCalendars;
  },
};
